import { useModalStore } from '@/shared/lib/store/model/modal.store';
import * as Dialog from '@radix-ui/react-dialog';
import { QRCodeSVG } from 'qrcode.react';
import { useRef } from 'react';

export const PublishedQrPopup = ({
    publishType = 1,
    title,
    shareUrl,
}: {
    publishType?: number;
    title?: string;
    shareUrl?: string;
}) => {
    const { closeModal } = useModalStore();
    const qrRef = useRef<HTMLDivElement>(null);
    const onDownload = async () => {
        if (!qrRef.current) return;
        try {
            const { default: html2canvas } = await import('html2canvas');
            if (!qrRef.current) return;
            // div 요소를 캡처하여 Canvas로 변환
            const canvas = await html2canvas(qrRef.current);

            // Canvas를 데이터 URL(PNG)로 변환
            const dataUrl = canvas.toDataURL('image/png');

            // 가상의 <a> 태그를 생성하여 파일 다운로드
            const link = document.createElement('a');
            link.href = dataUrl;
            link.download = 'qr.png'; // 파일명
            link.click();
        } catch (error) {
            console.error('Error capturing div as PNG:', error);
        }
    };

    const onPrint = () => {
        if (!qrRef.current) return;

        // 새 창에 QR 코드를 렌더링하고 인쇄
        const printWindow = window.open('', '_blank');
        if (printWindow) {
            const qrHtml = qrRef.current.innerHTML; // QR 코드 HTML 가져오기
            printWindow.document.write(`
            <html>
              <head>
                <title>QR 코드 인쇄</title>
                <style>
                  body {
                    text-align: center;
                    margin: 100px;
                    font-family: Arial, sans-serif;
                  }
                  .qr-container {
                    display: inline-block;
                    padding: 20px;
                  }
                </style>
              </head>
              <body>
                <div class="qr-container">
                  ${qrHtml}
                </div>
                <script>
                  window.print();
                </script>
              </body>
            </html>
          `);
            printWindow.document.close();
        }
    };

    const createUrl = () => {
        if (publishType === 1) {
            return `homework/${'taskId'}/${'claId'}`;
        }
    };

    return (
        <div className="pop_wrap publish_option complite qrcode">
            <div className="pop_contents publish_option_popcont qrcode">
                <div className="set-file-content">
                    {/* 상단 콘텐츠 */}
                    <div className="form-row">
                        <div className="form-td">
                            <div className="cont_wrap">
                                <div className="cont_wrap_inner flex_c search-form bor_b_none qrcode">
                                    <div className="popup_cont_title">
                                        <p className="txtCenter">
                                            <strong>
                                                <span className="txt_point">{title}</span>
                                            </strong>
                                        </p>
                                        <p className="txtCenter summary_txt">
                                            <strong>
                                                학생들은 아래 QR을 통해 평가에 응시할 수 있습니다.
                                            </strong>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* QR 코드 영역 */}
                    <div className="form-row">
                        <div className="form-td">
                            <div className="cont_wrap">
                                <div className="cont_wrap_inner qrcode_wrap">
                                    <div className="qrcode_img" ref={qrRef}>
                                        <QRCodeSVG
                                            value={shareUrl ?? ''}
                                            style={{ width: '100%', height: '100%' }}
                                        />
                                        {/* <img
                                    src="assets/images/ttukttak/common/qrcode.svg"
                                    alt="큐알코드"
                                /> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 버튼 영역 */}
                    <div className="bt_wrap cont-mt2">
                        <button
                            className="btn btn-default icon blue2 download_w"
                            onClick={onDownload}
                        >
                            <i></i>다운로드
                        </button>
                        <button className="btn btn-default icon pink print_w" onClick={onPrint}>
                            <i></i>인쇄하기
                        </button>
                    </div>
                </div>
            </div>

            {/* 팝업 닫기 버튼 */}
            <Dialog.Close asChild>
                <button
                    type="button"
                    className="btn-x"
                    onClick={() => closeModal('publish-qr-popup')}
                >
                    <span className="sr-only">팝업 닫기</span>
                </button>
            </Dialog.Close>
        </div>
    );
};
